<template>
  <Widget
    id="news-widget"
    :title="'<div><h6> Referensi </h6><span class=text-muted>Anda dapat menemukan refrensi dihalaman ini</span></div>'"
    customHeader
    bodyClass="p-0"
    :showLoader="false"
  >
    <ul class="news-list stretchable">
      <li>
        <span class="icon text-white bg-success"
          ><i class="fa fa-book"></i
        ></span>
        <div class="news-item-info">
          <h5 class="name m-0 mb-xs">
            <a href="https://drive.google.com/file/d/16UfybcgoVeHucN_rzKETwYJ1vdKXg5J1/view" target="blank">Manual Book Penggunaan Aplikasi E-Sea</a>
          </h5>
          <time class="help-block">Des 18, 18:46</time>
        </div>
      </li>
      <li>
        <span class="icon text-white bg-danger"
          ><i class="fa fa-youtube"></i
        ></span>
        <div class="news-item-info">
          <h5 class="name m-0 mb-xs">
            <a href="https://drive.google.com/file/d/104BmG3jAfEqz4xjQeBHevZies_DhTdiK/view" target="blank">Video Tutorial Penggunaan Aplikasi E-Sea</a>
          </h5>
          <time class="help-block">Des 18, 18:46</time>
        </div>
      </li>
    </ul>
  </Widget>
</template>

<script>
export default {};
</script>

<style src="./Grid.scss" lang="scss" />
